import { Component, Inject, ElementRef, Optional, OnInit,ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import {COMMA, ENTER} from '@angular/cdk/keycodes';
import { first } from 'rxjs/operators';
import {MatSnackBar} from '@angular/material/snack-bar';
import { NodoEstructuraJerarquica } from 'app/main/models/nodo-estructura-jerarquica.model';
import { UsersService } from 'app/main/services/users.service';
import { Usuario } from 'app/main/models/usuario.model';
import {FormControl} from '@angular/forms';
import {MatAutocompleteSelectedEvent, MatAutocomplete} from '@angular/material/autocomplete';
import {MatChipInputEvent} from '@angular/material/chips';
import {Observable} from 'rxjs';
import {map, startWith} from 'rxjs/operators';
import {TranslateService} from '@ngx-translate/core';
import { EstructuraJerarquicaService } from '../../../services/estructura-jerarquica.service';


@Component({
  selector: 'app-dialog-box-change-tree',
  templateUrl: './dialog-box-change-tree.component.html',
  styleUrls: ['./dialog-box-change-tree.component.scss']
})
export class DialogBoxChangeTreeComponent {

  action: string;
  LOCAL_DATA: any;
  destino: any;
  origen: any;

  constructor(
    private service: EstructuraJerarquicaService,
    public translate: TranslateService,
    public dialogRef: MatDialogRef<DialogBoxChangeTreeComponent>,
    private _snackBar: MatSnackBar,
    // @Optional() is used to prevent error if no data is passed
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any) {
    console.log(data);
    this.dialogRef.disableClose = true;
    this.LOCAL_DATA = data.nodo;
    this.destino = data.destino;
    this.origen = data.origen;
    this.action = data.action;
  }

  doAction(): void{
    var id = this.LOCAL_DATA.valor.id;
    
    //Si es el raiz no tiene valor.
    var nodoDestino = this.destino;
    if(this.destino.valor!=null && this.destino.valor.id!=null){
      nodoDestino = this.destino.valor;
    }

    if(id!=null){
      this.service.editFatherNode(id, nodoDestino).pipe(first()).subscribe(
        data => {
          console.log(data);
          this.openSnackBar("Se actualizó la estructura jerarquíca correctamente.","Cerrar");
          this.dialogRef.close({event: this.action});
        },
        error => {
          console.log(error);
          this.openSnackBar("No se pudo actualizar la estructura jerarquíca correctamente, ocurrió un error.","Cerrar");
        }
      );
    }else{

      
      this.dialogRef.close({event: this.action,destino: this.destino});
    }
  }

  closeDialog(): void{
    this.dialogRef.close({event: 'Cancel'});
  }

  ngOnInit(): void {

  }

  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 3000,
    });
  }



}
